import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AnyObject, ErrorMessage, FileValue } from '@mri/types';
import { GenericResourceService } from '@mri/app/resources';
import { Observable, of, tap } from 'rxjs';

@Component({
  selector: 'app-field-image',
  templateUrl: './field-image.component.html',
  styleUrl: './field-image.component.scss'
})
export class FieldImageComponent {

  private _classSet: Set<string> = new Set<string>();
  private _isChange: boolean = false;

  source: string = 'assets/images/placeholder.png';
  name: string = '';

  @ViewChild('inputFile') inputFile: ElementRef<HTMLInputElement>;

  @Output() valueChange = new EventEmitter<FileValue>;
  @Input() placeholder?: string;
  @Input() mode?: string;
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;

  @Input() set value(value: FileValue) {
    if (!value) return;
    if (value.url === this.source) return;
    if (value.data === this.source) return;

    this.source = value.url || this.source;
    this.name = value.name || this.name;
  }

  constructor(
    private _genericSrv: GenericResourceService,
  ) {
  }


  uploadSource(): Observable<AnyObject>{
    if(!this._isChange) return of(null);

    return this._genericSrv.postElement<FileValue>('files/upload/image', {
      data: this.source,
      name: this.name
    })
      .pipe(
        tap( (value) => {
          this.source = value.url || '';
          this._isChange = false;
          this.valueChange.emit(value);
        })
      )
  }


  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onChange(event: AnyObject) {
    const file = event.target.files[0];

    const name = event.target.value.split(/(\\|\/)/g).pop();

    // Encode the file using the FileReader API
    const reader = new FileReader();
    reader.onloadend = () => {
      this._isChange = true;
      this.source = reader.result as string;
      this.name = name;
      this.valueChange.emit({
        data: this.source,
        name
      });
      // Logs data:<type>;base64,wL2dvYWwgbW9yZ...
    };
    reader.readAsDataURL(file);
  }

  onFocus() {
    this._classSet.add('card-focus');
  }

  onBlur() {
    this._classSet.delete('card-focus');
  }

  onClick() {
    console.log('InputFile', this.inputFile);
    this.inputFile.nativeElement.click();
  }
}
